import { axios } from '@Root/API'

export const getSuspensions = params => {
	return axios.get('students/course-session/suspensions', { params })
}
